// src/utils/downloadProgress.ts

export const BYTES_PER_KB = 1024;
export const MS_PER_SEC = 1000;
const DECIMAL_PLACES = 2;

export interface ChunkProgress {
  speedMBps: number;
  chunksRemaining?: number;
}

/**
 * Calculate download progress metrics from chunk data.
 * Mirrors HAP's calculateChunkProgress function.
 *
 * @param fetchedBytes - Total bytes fetched so far
 * @param chunkCount - Number of chunks received
 * @param startTime - Download start timestamp (Date.now())
 * @param expectedSize - Expected total file size (optional)
 * @returns Progress metrics including speed and estimated remaining chunks
 */
export function calculateChunkProgress(
  fetchedBytes: number,
  chunkCount: number,
  startTime: number,
  expectedSize?: number
): ChunkProgress {
  const elapsedSec = (Date.now() - startTime) / MS_PER_SEC;
  const speedMBps = elapsedSec > 0 ? (fetchedBytes / BYTES_PER_KB / BYTES_PER_KB) / elapsedSec : 0;

  const avgChunkSize = chunkCount > 0 ? fetchedBytes / chunkCount : 0;
  const remainingBytes = expectedSize !== undefined ? expectedSize - fetchedBytes : undefined;
  const chunksRemaining = remainingBytes !== undefined && avgChunkSize > 0
    ? Math.ceil(remainingBytes / avgChunkSize)
    : undefined;

  return {
    speedMBps: Number(speedMBps.toFixed(DECIMAL_PLACES)),
    chunksRemaining
  };
}
